var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntiTemperDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 353,
    viewBox: "0 0 368 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 132,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_415_4638)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 123,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_415_4638)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 123.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_415_4638)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_4638)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_415_4638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.018 170C153.125 169.93 153.198 169.82 153.224 169.695C153.25 169.571 153.225 169.441 153.155 169.335C150.863 165.849 149.809 161.694 150.161 157.537C150.512 153.38 152.25 149.462 155.094 146.411L160.882 152.19C159.444 153.867 158.576 155.958 158.405 158.161H156.762C156.549 158.161 156.345 158.246 156.195 158.396C156.045 158.546 155.96 158.75 155.96 158.963C155.96 159.175 156.045 159.379 156.195 159.529C156.345 159.68 156.549 159.764 156.762 159.764H158.405C158.576 161.967 159.444 164.058 160.882 165.736L154.942 171.675C154.793 171.825 154.709 172.029 154.709 172.24C154.709 172.452 154.793 172.655 154.942 172.805C155.092 172.955 155.295 173.038 155.507 173.038C155.719 173.038 155.922 172.955 156.072 172.805L162.012 166.866C163.684 168.318 165.776 169.2 167.983 169.383V170.986C167.983 171.198 168.068 171.402 168.218 171.553C168.368 171.703 168.572 171.787 168.785 171.787C168.997 171.787 169.201 171.703 169.352 171.553C169.502 171.402 169.586 171.198 169.586 170.986V169.383C171.789 169.211 173.88 168.344 175.558 166.906L181.337 172.685C178.247 175.51 174.292 177.205 170.115 177.494C165.802 177.799 161.52 176.567 158.028 174.016C157.856 173.893 157.642 173.844 157.433 173.878C157.224 173.913 157.038 174.029 156.914 174.2C156.852 174.286 156.809 174.384 156.785 174.487C156.761 174.59 156.758 174.697 156.776 174.801C156.794 174.906 156.832 175.005 156.889 175.095C156.946 175.184 157.02 175.261 157.106 175.322C159.947 177.338 163.266 178.575 166.733 178.908C170.2 179.242 173.694 178.661 176.866 177.223C180.039 175.785 182.779 173.541 184.814 170.714C186.848 167.887 188.107 164.576 188.463 161.111C188.955 156.52 187.82 151.902 185.257 148.062C185.185 147.957 185.075 147.885 184.951 147.859C184.827 147.834 184.698 147.858 184.591 147.925C184.485 147.996 184.411 148.105 184.386 148.23C184.36 148.355 184.385 148.484 184.455 148.591C186.746 152.077 187.801 156.231 187.449 160.388C187.097 164.545 185.36 168.463 182.515 171.515L176.728 165.736C178.166 164.058 179.033 161.967 179.205 159.764H180.808C181.021 159.764 181.224 159.68 181.375 159.529C181.525 159.379 181.609 159.175 181.609 158.963C181.609 158.75 181.525 158.546 181.375 158.396C181.224 158.246 181.021 158.161 180.808 158.161H179.205C179.033 155.958 178.166 153.867 176.728 152.19L182.668 146.25C182.799 146.097 182.867 145.9 182.86 145.698C182.852 145.496 182.768 145.305 182.626 145.162C182.483 145.019 182.291 144.936 182.09 144.928C181.888 144.92 181.691 144.989 181.537 145.12L175.598 151.059C173.91 149.614 171.803 148.746 169.586 148.583V146.94C169.586 146.727 169.502 146.523 169.352 146.373C169.201 146.222 168.997 146.138 168.785 146.138C168.572 146.138 168.368 146.222 168.218 146.373C168.068 146.523 167.983 146.727 167.983 146.94V148.583C165.78 148.754 163.689 149.622 162.012 151.059L156.233 145.28C159.33 142.476 163.285 140.801 167.454 140.527C171.766 140.218 176.048 141.444 179.542 143.99C179.627 144.06 179.725 144.111 179.831 144.141C179.937 144.171 180.048 144.179 180.157 144.164C180.266 144.149 180.371 144.112 180.465 144.055C180.56 143.998 180.641 143.922 180.704 143.832C180.768 143.742 180.812 143.64 180.834 143.532C180.857 143.424 180.856 143.313 180.834 143.205C180.811 143.097 180.767 142.995 180.703 142.906C180.639 142.816 180.558 142.74 180.463 142.683C177.629 140.669 174.316 139.432 170.855 139.094C167.394 138.757 163.904 139.331 160.734 140.76C157.563 142.188 154.822 144.422 152.782 147.239C150.743 150.055 149.475 153.357 149.107 156.815C148.627 161.41 149.775 166.029 152.353 169.864C152.425 169.968 152.534 170.041 152.658 170.066C152.782 170.092 152.911 170.068 153.018 170ZM167.983 150.186C167.983 150.398 168.068 150.602 168.218 150.753C168.368 150.903 168.572 150.987 168.785 150.987C168.997 150.987 169.201 150.903 169.352 150.753C169.502 150.602 169.586 150.398 169.586 150.186C171.645 150.365 173.576 151.262 175.041 152.719C176.506 154.177 177.412 156.103 177.602 158.161C177.389 158.161 177.185 158.246 177.035 158.396C176.885 158.546 176.8 158.75 176.8 158.963C176.8 159.175 176.885 159.379 177.035 159.529C177.185 159.68 177.389 159.764 177.602 159.764C177.421 161.829 176.519 163.765 175.053 165.231C173.587 166.697 171.651 167.599 169.586 167.78C169.586 167.567 169.502 167.363 169.352 167.213C169.201 167.063 168.997 166.978 168.785 166.978C168.572 166.978 168.368 167.063 168.218 167.213C168.068 167.363 167.983 167.567 167.983 167.78C165.918 167.599 163.983 166.697 162.517 165.231C161.051 163.765 160.148 161.829 159.968 159.764C160.18 159.764 160.384 159.68 160.535 159.529C160.685 159.379 160.769 159.175 160.769 158.963C160.769 158.75 160.685 158.546 160.535 158.396C160.384 158.246 160.18 158.161 159.968 158.161C160.157 156.103 161.064 154.177 162.529 152.719C163.994 151.262 165.924 150.365 167.983 150.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.193 167.579C156.302 167.514 156.381 167.409 156.412 167.285C156.444 167.162 156.425 167.032 156.361 166.922C155.486 165.405 154.889 163.744 154.597 162.017C154.601 161.995 154.601 161.974 154.597 161.952C154.546 161.77 154.425 161.615 154.261 161.521C154.096 161.427 153.902 161.402 153.719 161.45C153.536 161.499 153.379 161.617 153.282 161.78C153.186 161.943 153.157 162.137 153.203 162.321C153.692 164.158 154.506 165.893 155.607 167.443C155.675 167.529 155.77 167.589 155.876 167.614C155.982 167.638 156.094 167.626 156.193 167.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.011 150.483C181.942 150.385 181.838 150.317 181.721 150.292C181.604 150.267 181.481 150.286 181.378 150.346C181.269 150.411 181.19 150.517 181.158 150.64C181.127 150.763 181.145 150.894 181.21 151.004C182.085 152.521 182.682 154.182 182.973 155.909C182.969 155.93 182.969 155.952 182.973 155.973C182.996 156.066 183.037 156.153 183.094 156.23C183.151 156.307 183.223 156.372 183.306 156.42C183.388 156.469 183.479 156.501 183.574 156.514C183.669 156.527 183.765 156.522 183.858 156.497C183.95 156.473 184.037 156.43 184.113 156.372C184.189 156.313 184.252 156.241 184.3 156.158C184.347 156.075 184.378 155.983 184.389 155.888C184.401 155.793 184.394 155.697 184.368 155.604C183.894 153.77 183.096 152.036 182.011 150.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.174 161.776L165.298 161.039C165.542 161.567 165.9 162.035 166.345 162.409C166.791 162.783 167.314 163.055 167.876 163.204C168.439 163.353 169.027 163.377 169.6 163.272C170.173 163.168 170.715 162.939 171.189 162.602L172.648 163.876C172.754 163.982 172.898 164.042 173.049 164.042C173.199 164.042 173.343 163.982 173.45 163.876C173.556 163.77 173.616 163.626 173.616 163.475C173.616 163.325 173.556 163.181 173.45 163.075L170.331 159.508L170.251 159.42C170.073 159.266 169.842 159.19 169.608 159.206C169.374 159.223 169.156 159.331 169.001 159.508C168.848 159.684 168.772 159.914 168.788 160.147C168.805 160.38 168.913 160.597 169.089 160.75L169.939 161.496C169.618 161.648 169.268 161.727 168.913 161.728C168.437 161.728 167.972 161.587 167.577 161.323C167.181 161.059 166.873 160.683 166.691 160.244C166.509 159.804 166.462 159.321 166.554 158.854C166.647 158.388 166.876 157.959 167.212 157.623C167.549 157.287 167.977 157.058 168.444 156.965C168.91 156.872 169.394 156.92 169.833 157.102C170.272 157.284 170.648 157.592 170.912 157.987C171.176 158.383 171.317 158.848 171.317 159.323C171.317 159.536 171.402 159.74 171.552 159.89C171.702 160.04 171.906 160.125 172.119 160.125C172.332 160.125 172.535 160.04 172.686 159.89C172.836 159.74 172.92 159.536 172.92 159.323C172.915 158.548 172.686 157.791 172.259 157.143C171.832 156.496 171.226 155.986 170.516 155.676L170.933 153.865C170.957 153.749 170.939 153.629 170.88 153.526C170.822 153.424 170.728 153.346 170.616 153.309C170.504 153.271 170.382 153.276 170.273 153.322C170.165 153.369 170.077 153.453 170.027 153.56L169.225 155.356C169.105 155.356 168.993 155.316 168.873 155.316C167.81 155.316 166.79 155.738 166.039 156.489C165.287 157.241 164.865 158.26 164.865 159.323C164.857 159.457 164.857 159.591 164.865 159.724L162.709 160.894C162.592 160.956 162.504 161.062 162.465 161.188C162.426 161.314 162.439 161.451 162.5 161.568C162.562 161.685 162.668 161.772 162.794 161.811C162.92 161.85 163.057 161.838 163.174 161.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.015 159.764C184.458 159.764 184.816 159.405 184.816 158.963C184.816 158.52 184.458 158.161 184.015 158.161C183.572 158.161 183.213 158.52 183.213 158.963C183.213 159.405 183.572 159.764 184.015 159.764Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_415_4638",
    x: 0,
    y: 0,
    width: 368,
    height: 353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_415_4638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_415_4638",
    result: "effect2_dropShadow_415_4638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_415_4638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_415_4638",
    x: 145,
    y: 139,
    width: 47.5752,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784314 0 0 0 0 0.745098 0 0 0 0 0.745098 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_4638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_4638",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_4638",
    x1: 95.8244,
    y1: 53.3182,
    x2: 166.887,
    y2: 66.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_4638",
    x1: 211.029,
    y1: 172.552,
    x2: 145.042,
    y2: 167.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_4638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(147 137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiTemperDark);
export default __webpack_public_path__ + "static/media/antiTemperDark.6469d32da7561728030e8490fc705669.svg";
export { ForwardRef as ReactComponent };